import * as React from "react";

import { Box, Typography } from "@mui/material";

export default function Disabled() {
	return (
		<React.Fragment>
			<Box
				sx={{
					bgcolor: "white",
					height: "100%",
					width: { xs: "100%", sm: "calc(100% - 4px)" },
					p: 3,
					overflow: "auto",
					borderRadius: "18px 18px 0px 0px",
					textAlign: "center",
				}}
			>
				<Typography
					variant="h5"
					sx={{
						display: "flex",
						justifyContent: "center",
						mt: 1,
						color: "#06b6ad",
						textAlign: "center",
						flexDirection: "column",
					}}
				>
					<Box>The LLN Quiz is currently unavailable due to administration issues.</Box>
					<Box>Please contact your training organisation to find out when it will be available.</Box>
				</Typography>
			</Box>
		</React.Fragment>
	);
}
